import { useState } from "react";
import { FetchedTiers, Tier } from "./types";
import { GET_TIERS } from "./queries";
import { useQuery } from "@apollo/client";
import TitleUpdater from "../../../components/common/TitleUpdater";
import { TitleBar } from "../../../components";
import QueryErrorBoundary from "../../../components/error-handling";
import TableV3 from "../../../components/generic/Table/TableV3";
import { TableColumnsType } from "antd";
import { TierBadge } from "./components";

const TiersDashboard = () => {
    const [tiers, setTiers] = useState<Tier[]>([]);

    const { loading, error } = useQuery<FetchedTiers>(GET_TIERS, {
    onCompleted: ({ getTiers: tiers }) =>
        setTiers(tiers),
    });

    const columns: TableColumnsType<Tier> = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          width: 120,
          align: 'center',
          render: (name: string, { color }: Tier) => (
            <TierBadge
                color={color}
                name={name}
            />
          ),
        },
        {
          title: 'Description',
          dataIndex: 'description',
          key: 'description',
          align: 'center',
          render: (description: string) => (
            <span className="custom-table--column">{description}</span>
          ),
        },
        {
          title: 'Key Features',
          dataIndex: 'keyFeatures',
          key: 'keyFeatures',
          align: 'center',
          render: (keyFeatures: string) => (
            <span className="custom-table--column">{keyFeatures}</span>
          ),
        },
        {
          title: 'Risk Level',
          dataIndex: 'riskLevel',
          key: 'riskLevel',
          align: 'center',
          render: (riskLevel: string) => (
            <span className="custom-table--column">{riskLevel}</span>
          ),
        },
        {
          title: 'Cost',
          dataIndex: 'cost',
          key: 'cost',
          align: 'center',
          render: (cost: string) => (
            <span className="custom-table--column">{cost}</span>
          ),
        },
      ];

    return (
        <>
            <TitleUpdater title="Tiers" />
            <TitleBar
                title="Tiers"
                subtitle={`The disaster recovery tier list and definitions`}
            />
            <QueryErrorBoundary error={error}>
                <TableV3
                    columns={columns}
                    data={tiers}
                    loading={loading}
                />
            </QueryErrorBoundary>
        </>
    )
}

export default TiersDashboard;